import React, { Component, useState, useEffect, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
    position: 'relative'
  },
  mainTitleText: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 700
  },  
  titleText: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 700
  },
  linearProgress: {
    marginTop: theme.spacing(-3),
    marginLeft: theme.spacing(-3),
    position: 'absolute',
    height: '2px',
    overflow: 'hidden',
    width: '100%',
  },
})

const Panel = ({ theme, classes, children, inProgress, ...props}) => {
  
  const { title, isMainPanel=false, actionButtons, backButton } = props
  
  const hasTitleBar = Boolean(title || actionButtons || backButton)
  
  
  return (
    <Paper 
      className={classes.root}
      elevation={2}
      >
      { inProgress &&
        <div className={classes.linearProgress}>
          <LinearProgress />          
        </div>
      }
      
      { hasTitleBar &&
        <Box display='flex' alignItems={ backButton ? 'flex-start' : 'center' }>
          { (backButton || title) &&
          <Box flexGrow={1}>
            { backButton }
            <Typography 
              component={isMainPanel ? 'h2' : 'h3'} 
              className={isMainPanel ? classes.mainTitleText : classes.titleText}>
              { title }
            </Typography>
          </Box>
          }
          
          { actionButtons && Array.isArray(actionButtons) ?
            actionButtons.map(btn =>
              <Box flexShrink={0}>            
                {btn}
              </Box>
            ).reduce((p, n) => p ?
                [...p, <Box mr={1} />, n] : [n], null)
            :
            actionButtons
          }
          
        </Box>
      }
      
      <Box mt={hasTitleBar ? 1 : 0}>
        { children }
      </Box>
    </Paper>
  )
}

export default withStyles(styles, { withTheme: true })(
  Panel
)
